import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import patternBg from '../../assets/images/bg-3938.jpeg';

export const container = css`
  @media (min-width: ${breakpoints.md.up}) {
    display: flex;
    min-height: 680px;
    height: 100vh;
  }

  @media (max-width: ${breakpoints.md.down}) {
    display: block; /* Stack content vertically on smaller screens */
    min-height: auto; /* Allow height to adjust based on content */
    padding: 20px; /* Add padding for better spacing */
  }

  &.is-show {
    opacity: 1;
    visibility: visible;
  }
`;

export const leftPanel = css`
  display: flex;
  align-items: flex-start; /* Align content to the top */
  justify-content: center;
  flex: 0 0 50%;
  padding-top: 20px; /* Space from the top */

  img {
    display: block;
    width: 500px; /* Set a larger width */
    height: 500px; /* Set a larger height */
    object-fit: cover; /* Ensures the image scales properly */

    @media (min-width: ${breakpoints.md.up}) {
      width: 450px; /* Even larger on bigger screens */
      height: 480px;
    }
  }
`;

export const rightPanel = css`
  flex: 0 0 50%;
  // padding: 20px 30px;
  // border:2px solid red;
  background: ${appColors.white};
  display: flex;
  flex-direction: column;
  @media (min-width: ${breakpoints.lg.up}) {
    padding: 40px 64px;
  }
`;

export const logo = css`
  max-width: 63px;
  display: block;
  margin-left: auto;
`;

export const authContainer = css`
// border:2px solid red;
  width: 100%;
  max-width: 490px;
  // margin: auto;
`;

export const heading = css`
  // border:2px solid red;
  margin: 0 0 14px;
  font-size: 36px;
  font-family: ${fontFamily.fredoka};
  color: ${appColors.blue800};
`;

export const subHeading = css`
  color: ${appColors.orange};
  font-size: 24px;
  margin: 0 0 25px;
`;

export const form = `
  .input {
    padding: 0 20px !important;
    font-size: 13px !important;
    color: ${appColors.gray500} #5a5a5b !important;
    background-color: ${appColors.gray200} !important;
    border: 1px solid ${appColors.gray200} !important;
    border-radius: 13px !important;
    -webkit-box-sizing: border-box;
    font-family: inherit !important;
    height: 50px !important;
  }
  .label {
    display: none;
  }
  .form-section-header {
    margin: 0 0 5px !important;
  }
  .form-section-header h3 {
    margin: 0 !important;
  }
  #password-hint > div {
    margin-bottom: -40px;
  }
  #password-hint > div,
  .sign-in-form-footer,
  .sign-up-form-footer {
    font-family: ${fontFamily.poppins} !important;
    text-align: right;
    color: ${appColors.gray500} !important;
  }
  .sign-in-form-footer,
  .sign-up-form-footer {
    flex-direction: column-reverse !important;
    justify-content: center !important;
    align-items: center !important;
    padding-top: 30px !important;
  }
  .form-section-footer {
    padding-top: 30px !important;
    flex-direction: column !important;
  }
  .anchor {
    color: ${appColors.orange} !important;
  }
  .auth-fields {
    margin-bottom: 0px !important;
  }
  .button {
    width: 100%;
    height: 57px;
    background: ${appColors.orange} !important;
    font-size: 18px;
    border-radius: 13px ;
    margin-bottom: 30px !important;
    
  }
  amplify-button {
    width: 100% !important;
  }
  @media (min-width: ${breakpoints.md.up}) {
    .button {
      max-width: 279px !important;

    }
  }
`;
